export default __webpack_public_path__ + "static/media/Katja.b61bbc8b.jpg";